<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form
            v-if="isSearch"
            :model="queryForm"
            ref="form"
            label-width="80px"
            :inline="true"
            size="small"
            class="query-form"
            @submit.native.prevent
        >
            <el-form-item label="用户账号">
                <el-input v-model="queryForm.userName" placeholder="请选择用户账号"></el-input>
            </el-form-item>
            <el-form-item label="订单ID">
                <el-input v-model="queryForm.orderId" placeholder="请选择订单ID"></el-input>
            </el-form-item>
            <el-form-item label="产品名称">
                <el-input v-model="queryForm.productName" placeholder="请选择产品名称"></el-input>
            </el-form-item>
            <el-form-item label="评价等级">
                <el-select
                    class="selectInput"
                    v-model="queryForm.commentGrade"
                    size="small"
                    placeholder="请选择评价等级"
                    clearable
                    style="width: 180px"
                >
                    <el-option v-for="item in commentGradeList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getShopUserCommentList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group"></div>

                <div class="icon-group">
                    <span title="搜索" class="icon-box" @click="search">
                        <Icon color="#606266">
                            <Search />
                        </Icon>
                    </span>
                    <span class="icon-box" @click="refreshShopUserCommentList">
                        <Icon color="#606266">
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table :data="shopUserCommentList" row-key="id" border @selection-change="handleSelectionChange" size="small" height='100%'>
                <el-table-column align="center" type="selection" width="60"> </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="mppUser.userName" label="用户账号" min-width="15%">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="orderId" label="订单ID" min-width="8%">
                    <template slot-scope="scop">
                        <div v-if="scop.row.orderId">{{ scop.row.orderId }}</div>
                        <div style="text-align: center" v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="shopProduct.productName"
                    label="产品名称"
                    min-width="15%"
                >
                </el-table-column>

                <el-table-column :show-overflow-tooltip="true" align="center" prop="commentContent" label="评价内容" min-width="20%">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="commentGrade" label="评价等级" min-width="8%">
                    <template slot-scope="scop">
                        <div v-if="scop.row.commentGrade == 3">差评</div>
                        <div v-if="scop.row.commentGrade == 2">中评</div>
                        <div v-if="scop.row.commentGrade == 1">好评</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="createTime" label="创建时间" min-width="12%">
                </el-table-column>
                <el-table-column fixed="right" align="center" label="操作" min-width="10%">
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="checkShopUserComment(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <div @click="deleteShopUserComment(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog :title="shopUserCommentStates[shopUserCommentState]" :visible.sync="showDialog" width="60%" @close="closeDialog">
                <div class="information">
                    <el-form
                        :model="shopUserComment"
                        ref="shopUserCommentForm"
                        :rules="rules"
                        label-width="80px"
                        :inline="true"
                        size="small"
                    >
                        <el-form-item label="用户账号" prop="mppUser.userName">
                            <el-input
                                size="small"
                                v-model="shopUserComment.mppUser.userName"
                                :disabled="shopUserCommentState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="产品名称" prop="shopProduct.productName">
                            <el-input
                                size="small"
                                v-model="shopUserComment.shopProduct.productName"
                                :disabled="shopUserCommentState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="评价内容" prop="commentContent">
                            <el-input
                                size="small"
                                v-model="shopUserComment.commentContent"
                                :disabled="shopUserCommentState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="评价等级" prop="commentGrade">
                            <el-select v-model="shopUserComment.commentGrade" size="small" :disabled="shopUserCommentState == 'check'">
                                <el-option v-for="item in commentGradeList" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="创建时间" prop="createTime">
                            <el-input
                                size="small"
                                :disabled="shopUserCommentState == 'check'"
                                v-model="shopUserComment.createTime"
                            ></el-input>
                        </el-form-item>

                        <el-form-item label="评价相册" prop="commentAlbum">
                            <template slot-scope="scope">
                                <div class="imgflex">
                                    <img class="img" v-for="item of shopUserComment.commentAlbum" :src="item" alt="" />
                                </div>
                            </template>
                        </el-form-item>
                    </el-form>
                </div>
                <div slot="footer" class="flex justify-end">
                    <el-button @click="closeDialog">关闭</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopUserCommentList();
                this.getShopUserCommentList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopUserCommentList();
                this.getShopUserCommentList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            queryForm: {
                productName: '', //所评价的产品id
                userName: '', //用户id
                commentGrade: '', //评价等级 1:好评 2:中评 3:差评
                orderId: ''
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            shopUserCommentState: 'add',
            shopUserCommentStates: {
                add: '新建评价',
                check: '查看评价',
                edit: '修改评价'
            },

            multipleSelection: [],
            shopUserCommentList: [],
            shopUserComment: {
                id: '', //评价id
                commentContent: '', //评价内容
                commentAlbum: '', //评价的相册
                shopProduct: { productName: '' }, //产品
                orderId: '', //订单id
                mppUser: { userName: '' }, //用户
                commentGrade: '', //评价等级
                commentType: '', //评价类型
                createUserId: '', //创建人
                createTime: '', //创建时间
                updateUserId: '', //更新人
                updateTime: '', //更新时间
                deleteFlag: '' //是否删除
            },
            btnLoading: false,
            rules: {},
            commentGradeList: [
                {
                    value: 3,
                    label: '差评'
                },
                {
                    value: 2,
                    label: '中评'
                },
                {
                    value: 1,
                    label: '好评'
                }
            ]
        };
    },
    created() {
        this.getShopUserCommentList();
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        resetShopUserCommentList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopUserCommentList = [];
        },
        resetDialog() {
            this.shopUserCommentState = 'add';
            this.showDialog = false;
            this.queryForm = {
                productName: '', //所评价的产品id
                userName: '', //用户id
                commentGrade: '', //评价等级 1:好评 2:中评 3:差评
                orderId: ''
            };
            this.getShopUserCommentList();
        },
        closeDialog() {
            this.showDialog = false;
            this.shopUserCommentState = 'add';
            this.shopUserComment = {
                id: '', //评价id
                commentContent: '', //评价内容
                commentAlbum: '', //评价的相册
                shopProduct: { productName: '' }, //所评价的产品id
                orderId: '', //订单id
                mppUser: { userName: '' }, //用户id
                commentGrade: '', //评价等级 1:好评 2:中评 3:差评
                commentType: '', //评价类型
                createUserId: '', //创建人
                createTime: '', //创建时间
                updateUserId: '', //更新人
                updateTime: '', //更新时间
                deleteFlag: '' //是否删除
            };
        },

        checkShopUserComment(shopUserCommentId) {
            console.log(shopUserCommentId);
            this.currentShopUserCommentId = shopUserCommentId;
            this.getShopUserCommentById();
            this.showDialog = true;
            this.shopUserCommentState = 'check';
        },
        refreshShopUserCommentList() {
            this.resetShopUserCommentList();
            this.getShopUserCommentList();
        },
        getShopUserCommentList() {
            this.loading = true;
            get(`/shop/productcomment/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then(
                (res) => {
                    this.loading = false;
                    if (res.success && res.code == 200) {
                        this.shopUserCommentList = res.page.list;
                        this.totalNum = res.page.total;
                    }
                }
            );
        },
        getShopUserCommentById() {
            get(`/shop/productcomment/get`, { id: this.currentShopUserCommentId }).then((res) => {
                if (res.success && res.code == 200) {
                    this.shopUserComment = { ...this.shopUserComment, ...res.shopProductComment };
                    if ((this.shopUserCommentState = 'check')) {
                        let str = this.shopUserComment.commentAlbum;
                        this.shopUserComment.commentAlbum = str.split('|');
                    }
                    console.log(this.shopUserComment);
                }
            });
        },
        deleteShopUserComment(shopUserCommentId) {
            let ids = '';
            if (shopUserCommentId) {
                ids = shopUserCommentId;
            } else {
                ids = this.multipleSelection.map((shopUserCoupon) => shopUserCoupon.id).join(',');
            }
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/shop/productcomment/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopUserCommentList();
                            this.getShopUserCommentList();
                        }
                    });
                })
                .catch(() => {});
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getShopUserCommentList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getShopUserCommentList();
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}

::v-deep .information .el-input {
    width: 200px;
}
.imgflex {
    display: flex;
    flex-wrap: wrap;
}
.img {
    width: 80px;
    height: 80px;
    margin-right: 10px;
    margin-bottom: 10px;
}
</style>
